import { LEVEL_SUCCESS } from "constant/messages";
import { put, take } from "redux-saga/effects";

import { addMessageAction } from "./actions";

function* forwardMessageSaga(actionTypes) {
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const action = yield take(actionTypes);

    const { message } = action.payload;

    if (message) {
      yield put(addMessageAction(LEVEL_SUCCESS, message));
    }
  }
}

export { forwardMessageSaga };
